import { Component, h, Prop, State, Watch } from '@stencil/core';
import { fetchSuggestions } from '../../services/videoService';
import { Suggestion } from '../../types/videoPlayer';
import { formatTimeAgo } from '../utils/control-utils';

@Component({
  tag: 'video-suggestions',
  styleUrl: 'Suggestions.css',
  shadow: true,
})
export class VideoSuggestions {
  @Prop() handlePlaySuggestion: (id: string) => void;
  @Prop() setSuggestions: (suggestions: Suggestion[]) => void;
  @Prop() baseUrl: string;
  @Prop() clientId: string;
  @Prop() videoId: string;
  @Prop() height: number;

  @State() suggestions: Suggestion[] = [];
  @State() page: number = 1;
  @State() limit: number = 5;
  @State() totalData: number = 0;

  async componentWillLoad() {
    const data = await fetchSuggestions(this, this.page, this.limit);
    this.suggestions = data.suggestions;
    this.totalData = data.totalCount;
    this.setSuggestions(data.suggestions);
  }

  @Watch('suggestions')
  handleSuggestions() {
    this.setSuggestions(this.suggestions);
  }

  private formatDuration(durationString: string): string {
    const totalSeconds = parseInt(durationString);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    const milliseconds = Math.round((totalSeconds % 1) * 100);
    const pad = (num: number) => num.toString().padStart(2, '0');
    if (hours > 0) {
      return `${hours}:${pad(minutes)}:${pad(seconds)}`;
    } else {
      return `${minutes}:${pad(seconds)}${milliseconds ? `.${milliseconds}` : ''}`;
    }
  }

  private async loadMoreSuggestions() {
    try {
      this.page = this.page + 1;
      const data = await fetchSuggestions(this, this.page, this.limit);
      this.suggestions = [...this.suggestions, ...data.suggestions];
      this.totalData = data.totalCount;
      this.setSuggestions(this.suggestions);
    } catch (error) {
      this.page -= 1;
    }
  }

  render() {
    return (
      <>
        {!!this.suggestions.length ? (
          <div class="suggestions-container" style={this.height ? { height: `${this.height}px` } : { height: '100%' }}>
            <p class="suggestion-title">Suggestions</p>
            <div class="suggestions-list">
              {this.suggestions.map(video => (
                <div class={`suggestion-card ${this.videoId === video.id ? 'selected' : ''}`} onClick={() => this.handlePlaySuggestion(video.id)}>
                  <div class="thumbnail-container">
                    {!!video.thumbnailPath ? (
                      <img src={video.thumbnailPath} alt={video.title} />
                    ) : (
                      <video src={video.outputFilePath} controls={false} autoPlay={false} preload="metadata" />
                    )}
                    <span class="duration">{this.formatDuration(video.duration)}</span>
                  </div>
                  <div class="suggestion-info">
                    <h4 class="title">{video.title} </h4>
                    <p class="meta">{formatTimeAgo(video.createdAt)}</p>
                  </div>
                </div>
              ))}
              {/* Load More Button (only show if more suggestions exist) */}
              {this.suggestions.length < this.totalData && (
                <div class="load-more-container">
                  <button onClick={() => this.loadMoreSuggestions()} class="load-more-btn">
                    Load More
                  </button>
                </div>
              )}
            </div>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  }
}
